export const shortestPathEdges = [
  {
    id: "10.5.112.134-102.80.143.201",
    source: "102.80.143.201",
    target: "10.5.112.134",
    type: "straight",
    label: 7,
  },
  {
    id: "10.5.112.134-71.20.12.201",
    source: "71.20.12.201",
    target: "10.5.112.134",
    type: "straight",
    label: 1,
  },
  {
    id: "71.20.12.201-135.156.222.108",
    source: "71.20.12.201",
    target: "135.156.222.108",
    type: "straight",
    label: 3,
  },
  {
    id: "48.189.46.255-135.156.222.108",
    source: "48.189.46.255",
    target: "135.156.222.108",
    type: "straight",
    label: 2,
  },
  {
    id: "48.189.46.255-71.20.12.201",
    source: "48.189.46.255",
    target: "71.20.12.201",
    type: "straight",
    label: 5,
  },
  {
    id: "10.5.112.134-135.156.222.108",
    source: "10.5.112.134",
    target: "135.156.222.108",
    type: "straight",
    label: 2,
  },
  {
    id: "25.44.79.53-135.156.222.108",
    source: "25.44.79.53",
    target: "135.156.222.108",
    type: "straight",
    label: 1,
  },
  {
    id: "10.5.112.134-25.44.79.53",
    source: "10.5.112.134",
    target: "25.44.79.53",
    type: "straight",
    label: 2,
  },
  {
    id: "25.44.79.53-102.80.143.201",
    source: "25.44.79.53",
    target: "102.80.143.201",
    type: "straight",
    label: 1,
  },
  {
    id: "48.189.46.255-172.251.238.79",
    source: "48.189.46.255",
    target: "172.251.238.79",
    type: "straight",
    label: 4,
  },
  {
    id: "135.156.222.108-172.251.238.79",
    source: "135.156.222.108",
    target: "172.251.238.79",
    type: "straight",
    label: 3,
  },
  {
    id: "25.44.79.53-172.251.238.79",
    source: "25.44.79.53",
    target: "172.251.238.79",
    type: "straight",
    label: 3,
  },
  {
    id: "25.44.79.53-159.199.179.144",
    source: "25.44.79.53",
    target: "159.199.179.144",
    type: "straight",
    label: 3,
  },
  {
    id: "2.133.220.187-25.44.79.53",
    source: "2.133.220.187",
    target: "25.44.79.53",
    type: "straight",
    label: 7,
  },
  {
    id: "159.199.179.144-172.251.238.79",
    source: "159.199.179.144",
    target: "172.251.238.79",
    type: "straight",
    label: 2,
  },
  {
    id: "57.200.0.1-2002:c0a8:101::1",
    source: "57.200.0.1",
    target: "2002:c0a8:101::1",
    type: "straight",
    label: 6,
  },
  {
    id: "2.133.220.187-102.80.143.201",
    source: "2.133.220.187",
    target: "102.80.143.201",
    type: "straight",
    label: 3,
  },
  {
    id: "2.133.220.187-159.199.179.144",
    source: "2.133.220.187",
    target: "159.199.179.144",
    type: "straight",
    label: 5,
  },
  {
    id: "2.133.220.187-194.200.5.136",
    source: "2.133.220.187",
    target: "194.200.5.136",
    type: "straight",
    label: 1,
  },
  {
    id: "48.189.46.255-51.247.206.27",
    source: "48.189.46.255",
    target: "51.247.206.27",
    type: "straight",
    label: 1,
  },
];
